// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterFrontImage_root__1RYil","title":"AfterFrontImage_title__37ljF"};